// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - ICON BUTTON ||============================== //

export default function IconButton(theme: Theme) {
  return {
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 4
        },
        sizeLarge: {
          width: theme.spacing(4.5),
          height: theme.spacing(4.5),
          fontSize: '1.125rem'
        },
        sizeMedium: {
          width: theme.spacing(4),
          height: theme.spacing(4),
          fontSize: '0.938rem'
        },
        sizeSmall: {
          width: theme.spacing(3.25),
          height: theme.spacing(3.25),
          fontSize: '0.688rem'
        }
      }
    }
  };
}
